class RelationshipSelector {
    constructor(InsuranceSuiteMetadata) {
        this._typelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('AccountRelationshipType');
        this.relationships = this._typelist.codes
            .map(c => {
                return {code: c.code, name: `gateway.contacts.AccountRelationshipType.typekey.${c.code}`};
            });
    }

    onRelChange(code) {
        this.onChange({value: code});
    }
}
RelationshipSelector.$inject = ['InsuranceSuiteMetadata'];

export default RelationshipSelector;
